import React from 'react';
import classnames from 'classnames';

import { CollaboratorAvatar, ItemMetadata, SelectMenu } from 'components';
import { fileTypeImageByType } from 'assets/img/fileTypes';

import styles from './AccessListItem.module.scss';
import feedListItemstyles from 'components/shared/FeedListItem/FeedListItem.module.scss';
import fileLinkStyles from 'components/shared/FeedListItem/components/FileLink/FileLink.module.scss';
import { AuditIcon } from '../AuditIcon';

interface props {
  node: any;
  buttonMessage: string;
  type?: string;
  showIntegration?: boolean;
}

export const AccessListItemNode = ({
  node,
  buttonMessage,
  type,
  showIntegration = false,
}: props) => {
  const integrationName = node?.integrationTitle || 'Integration';
  const integrationType =
    node?.integrationType?.slice(0, node?.integrationType?.indexOf('@')) || '';

  return (
    <div
      className={classnames(styles.container, styles.node, {
        [styles[`type--${type}`]]: type,
      })}
    >
      <div className={feedListItemstyles.iconWrapper}>
        <div className={feedListItemstyles.owner}>
          <div>
            <CollaboratorAvatar
              collaborator={{
                displayName: node?.owners[0]?.name || '',
                emailAddress: node?.owners[0]?.email || '',
                photoURL: node?.owners[0]?.avatarUrl || '',
              }}
              hoverEffects="Default"
            />
          </div>
        </div>
        <div className={feedListItemstyles.icon}>{fileTypeImageByType(node.category)}</div>
      </div>
      <div className={styles.dataContainer}>
        <div className={fileLinkStyles.title}>{node?.title}</div>
        <div className={styles.dataBody}>
          <ItemMetadata
            integrationType={node.integrationType}
            className={styles.meta}
            modified={node.modified}
          />
          <div className={styles.nodeMeta}>
            {showIntegration && node?.integrationType && (
              <div className={styles.meta}>
                {' in '}
                <AuditIcon className={styles.documentIcon} itemIntegrationName={integrationType} />
                {integrationName}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={styles.CTA}>
        <SelectMenu
          buttonClassName={styles.memberDropdownTrigger}
          arrow
          closeOnClick
          type="A"
          defaultLabel={buttonMessage}
          disabled
          horizontalPosition="Right"
          id={`1`}
          menuClassName={styles.menu}
          options={[
            {
              key: 'make_admin',
              label: 'Company Only',
              value: 'Company Only',
            },
          ]}
          value={buttonMessage}
        />
      </div>
    </div>
  );
};
